<script>
import Popper from 'popper.js';

export default {
    props: ['scheduleDate', 'schedule'],
    data() {
        return {
            popper: null,
            visible: true,
            scheduleDateId: null,
            schedulePopper: null,
            scheduleDateForm: new SparkForm({
                opponent_id: null,
                start_time: null,
                start_date: null,
                end_date: null,
                name: null,
                date_type: null,
            }),
        };
    },
    created() {
        this.scheduleDateId = _.get(this.scheduleDate, 'schedule_date.id');
        this.scheduleDateForm.end_date = _.get(this.scheduleDate, 'start');
        this.scheduleDateForm.start_date = _.get(this.scheduleDate, 'start');
        this.scheduleDateForm.name = _.get(this.scheduleDate, 'schedule_date.name');
        this.scheduleDateForm.date_type = _.get(this.scheduleDate, 'schedule_date.date_type');
        this.scheduleDateForm.start_time = _.get(this.scheduleDate, 'schedule_date.start_time');
        this.scheduleDateForm.opponent_id = _.get(this.scheduleDate, 'schedule_date.opponent_id');

        this.$nextTick(function () {
            if ($('.fc-highlight').length) {
                this.popper = new Popper($('.fc-highlight')[0], this.$refs.schedulePopper, {
                    placement: 'bottom',
                    modifiers: {
                        flip: {
                            behavior: ['left', 'bottom', 'top'],
                        },
                        preventOverflow: {
                            boundariesElement: $('#calendarContainer')[0],
                        },
                    },
                });
            }
        });
    },
    methods: {
        save() {
            const _this = this;
            const schedule_id = _.get(this.scheduleDate, 'schedule_date.id');

            if (schedule_id) {
                this.updateScheduleDate(schedule_id);
            } else {
                Spark.post('/api/team/schedule-dates', this.scheduleDateForm).then(() => {
                    _this.hide();
                    _this.$noty.success('Date updated');
                    Bus.$emit('scheduleDateCreated');
                });
            }
        },
        updateScheduleDate(schedule_id) {
            const _this = this;
            Spark.put('/api/team/schedule-dates/' + schedule_id, this.scheduleDateForm).then(() => {
                _this.hide();
                _this.$noty.success('Date updated');
                Bus.$emit('scheduleDateUpdated');
            });
        },
        deleteDate() {
            const _this = this;
            const schedule_id = _.get(this.scheduleDate, 'schedule_date.id');

            swalc('Are you sure?', confirm => {
                if (confirm) {
                    axios.delete('/api/team/schedule-dates/' + schedule_id).then(() => {
                        _this.hide();
                        _this.$noty.success('Date deleted');
                        Bus.$emit('scheduleDateUpdated');
                    });
                }
            });
        },
        hide() {
            this.visible = false;
        },
        show() {
            this.$nextTick(() => {
                this.visible = true;
            });
        },
    },
};
</script>
